import { GridColDef } from "@mui/x-data-grid-premium";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import { useTranslate } from "src/locales";
//IDOGAN;449733;25042025
export const usePageColumns = (): GridColDef[] => {
  const { t } = useTranslate();
  return getColumns(t);
};

export const getColumns = (t: (key: string) => string): GridColDef[] => [
  {
    field: "select",
    headerName: t("patient-diet-procedures.pages.select"),
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: () => <ByzMuiCheckBox />,
  },
  {
    field: "select2",
    headerName: "",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: () => (
      <ByzMuiOpenProcessMenu //CKAPISIZ;452424;05052024
        menuItems={[
          {
            label: t("patient-diet-procedures.favorites.add-favorites"),
            onClick() {
              console.log("Sık Kullanılanlara Eklendi.");
            },
          },
          {
            label: t("patient-diet-procedures.favorites.delete-favorites"),
            onClick() {},
            disabled: true,
          },
        ]}
        hideHeaderTitle
      />
    ),
  },
  {
    field: "sube",
    headerName: t("patient-diet-procedures.pages.branch"),
    width: 150,
  },
  {
    field: "ogun",
    headerName: t("patient-diet-procedures.pages.meal"),
    width: 120,
  },
  {
    field: "diyetTipi",
    headerName: t("patient-diet-procedures.pages.diet-type"),
    width: 150,
  },
  {
    field: "adi",
    headerName: t("patient-diet-procedures.pages.name"),
    width: 150,
  },
  {
    field: "not",
    headerName: t("patient-diet-procedures.pages.note"),
    width: 150,
  },
  {
    field: "diyabetik",
    headerName: t("patient-diet-procedures.pages.diabetic"),
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: () => <ByzMuiCheckBox circular checked />,
  },
  {
    field: "sonIstemTarihi",
    headerName: t("patient-diet-procedures.pages.last-request-date"),
    width: 150,
  },
];

export const rows = [
  {
    id: 1,
    sube: "Yazılım Test Ha",
    ogun: "Akşam",
    diyetTipi: "Normal",
    adi: "Normal",
    not: "",
    sonIstemTarihi: "17:00",
  },
  {
    id: 2,
    sube: "Yazılım Test Ha",
    ogun: "Akşam",
    diyetTipi: "Normal",
    adi: "Sulu Yemek",
    not: "",
    sonIstemTarihi: "17:00",
  },
  {
    id: 3,
    sube: "Yazılım Test Ha",
    ogun: "Akşam",
    diyetTipi: "Diyet Tansiyon",
    adi: "R1",
    not: "",
    sonIstemTarihi: "17:00",
  },
  {
    id: 4,
    sube: "Yazılım Test Ha",
    ogun: "Akşam",
    diyetTipi: "Diyet R2",
    adi: "R2",
    not: "",
    sonIstemTarihi: "17:00",
  },
  {
    id: 5,
    sube: "Yazılım Test Ha",
    ogun: "Akşam",
    diyetTipi: "Vegan Diyet",
    adi: "R3",
    not: "",
    sonIstemTarihi: "17:00",
  },
];
